export default __webpack_public_path__ + "static/media/CSM.f0852a94.webp";